export function formatDateToDDMMYYYY(dateInput, includeTime = false) {
  if (!dateInput) return "";

  let date;

  if (typeof dateInput === "string") {
    if (/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(dateInput)) {
      const parts = dateInput.split('/');
      date = new Date(parts[0], parts[1] - 1, parts[2]);
    } else {
      const normalized = dateInput.replace(" ", "T").replace(" IST", "");
      date = new Date(normalized);
    }
  } else {
    date = new Date(dateInput);
  }

  if (isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let formatted = `${day}-${month}-${year}`;

  if (includeTime) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    formatted += ` ${hours}:${minutes}`;
  }

  return formatted;
}
